<template>
  <div class="zhutuijilu-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="goBack">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.game_record') }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 表格标题 -->
    <div class="table-header">
      <div class="col col-time">{{ $t('my.time') }}</div>
      <div class="col col-amount">{{ $t('my.money') }}</div>
      <div class="col col-status">{{ $t('my.status') }}</div>
      <div class="col col-detail">{{ $t('my.detail') }}</div>
    </div>

    <!-- 拉刷新 -->
    <van-pull-refresh v-model="isLoading" @refresh="getBoostRecords">
      <!-- 记录列表 -->
      <div v-if="recordList.length === 0" class="empty-state">
        <van-empty :description="$t('withdraw.empty_data') || '暂无记录'" />
      </div>

      <div v-else class="record-list">
        <div
          v-for="(record, index) in recordList"
          :key="index"
          class="record-item"
        >
          <div class="col col-time">
            <span class="time-text">{{ record.time }}</span>
          </div>
          <div class="col col-amount">
            <span class="amount-text">{{ record.amount }} HKD</span>
          </div>
          <div class="col col-status">
            <!-- <span :class="['status-text', record.statusClass]">{{ record.status==0?'-'+record.amount:'+'+record.amount }}</span> -->
            <span class="detail-value" :class="{ 'win': record.is_win === 1, 'lose': record.is_win === 2, 'pending': record.is_win === 0 }">
                {{ record.is_win === 0 ? ($t('my.in_progress') || '進行中') : (record.is_win === 1 ? '+' : '-') + (record.profit || '0') + '' }}
              </span>
          </div>
          <div class="col col-detail">
            <van-icon
              name="arrow-down"
              class="expand-icon"
              :class="{ 'expand-open': expandedIndex === index }"
              @click="toggleExpand(index)"
            />
          </div>

          <!-- 展开详情 -->
          <div v-if="expandedIndex === index" class="record-detail">
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.order') || '訂單號' }}:</span>
              <span class="detail-value">{{ record.id || record.order_id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.time') || '助推時間' }}:</span>
              <span class="detail-value">{{ record.create_time || record.time }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.money') || '助推金額' }}:</span>
              <span class="detail-value">{{ record.amount }} HKD</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.status') || '狀態' }}:</span>
              <span class="detail-value" :class="{ 'win': record.is_win === 1, 'lose': record.is_win === 2, 'pending': record.is_win === 0 }">
                {{ record.is_win === 0 ? ($t('my.in_progress') || '進行中') : (record.is_win === 1 ? '+' : '-') + (record.profit || '0') + '' }}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.type') || '助推類型' }}:</span>
              <span class="detail-value">{{ record.win_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'Zhutuijilu',
  data() {
    return {
      expandedIndex: -1,
      recordList: [],
      isLoading: false
    };
  },
  methods: {
    toggleExpand(index) {
      this.expandedIndex = this.expandedIndex === index ? -1 : index;
    },
    goBack() {
      this.$router.go(-1);
    },
    getWinName(sum) {
      const lang = localStorage.getItem("lang");
      let result = '';
      
      if (sum >= 11 && sum <= 18) {
        result = lang == 'zh' ? '喜劇' : lang == 'en' ? 'Comedy' : lang == 'ja' ? 'コメディ' : '코미디';
      } else if (sum >= 3 && sum <= 10) {
        result = lang == 'zh' ? '科幻' : lang == 'en' ? 'Sci-Fi' : lang == 'ja' ? 'SF' : 'SF';
      }
      
      if (result) {
        const suffix = sum % 2 === 0 
          ? (lang == 'zh' ? '武俠' : lang == 'en' ? 'Martial Arts' : lang == 'ja' ? '武術' : '무협')
          : (lang == 'zh' ? '動作' : lang == 'en' ? 'Action' : lang == 'ja' ? 'アクション' : '액션');
        return result + ' ' + suffix;
      }
      
      return lang == 'zh' ? '未知' : lang == 'en' ? 'Unknown' : lang == 'ja' ? '未知' : '알 수 없음';
    },
    getBoostRecords() {
      this.isLoading = true;
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          const records = res.data || [];
          this.recordList = records.map(item => {
            // 格式化时间，如果是时间戳则转换
            let timeStr = item.create_time || item.time || '';
            if (typeof timeStr === 'number') {
              const date = new Date(timeStr * 1000);
              timeStr = date.toLocaleString('zh-CN').replace(/\//g, '-').replace(/,/, '\n');
            }

            // 确定状态样式
            const statusNum = parseFloat(item.money || item.amount || 0);
            const statusClass = statusNum > 0 ? 'positive' : 'negative';
            
            // 格式化显示的时间（表格列用）
            let displayTime = timeStr;
            if (displayTime.includes('\n')) {
              displayTime = displayTime.replace('\n', '\n');
            }

            // 根据 opencode 数组计算 sum 并获取对应的类型名称
            const opencode = item.opencode || [];
            const sum = opencode.reduce((acc, val) => acc + (parseFloat(val) || 0), 0);
            const winName = this.getWinName(sum);

            return {
              id: item.id || item.order_id || '',
              time: displayTime,
              create_time: item.create_time || item.time || '',
              amount: item.money || item.amount || '0.00 HKD',
              status: item.status || item.money || item.amount || '0',
              statusClass: statusClass,
              type: item.type || item.category || item.remark || '',
              detail: item.detail || item.remark || 'N/A',
              win_name: winName,
              ...item
            };
          });
        } else if (res.code === 401) {
          this.$toast(res.msg || 'Unauthorized');
          this.$router.push({ path: '/Login' });
        } else {
          this.$toast(res.msg || 'Failed to load records');
        }
        this.isLoading = false;
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getBoostRecords();
    }
  }
};
</script>

<style lang="less" scoped>
.zhutuijilu-page {
  min-height: 100vh;
  background: #151515;
  color: #f5f5f5;
  padding-bottom: 80px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #151515;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 32px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color:#22cc61;
}

.header-placeholder {
  width: 40px;
}

/* 表格 */
.table-header {
  display: grid;
  grid-template-columns:1.5fr 1.2fr 1.2fr 0.8fr;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  font-size: 28px;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.col-time {
  justify-content: flex-start;
  text-align: left;
}

.col-amount {
  justify-content: center;
}

.col-status {
  justify-content: center;
}

.col-detail {
  justify-content: center;
}

/* 记录列表 */
.record-list {
  padding: 0;
}

.record-item {
  display: grid;
  grid-template-columns: 1.5fr 1.2fr 1.2fr 0.8fr;
  gap: 12px;
  padding: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
}

.record-item:active {
  background: rgba(255, 255, 255, 0.02);
}

.time-text {
  font-size: 24px;
  color: #fff;
  white-space: pre-line;
  line-height: 1.4;
  padding:0 20px;
}

.amount-text {
  font-size: 24px;
  color: #fff;
  font-weight: 500;
  padding:0 20px;
}

.status-text {
  font-size: 24px;
  font-weight: 500;
	padding:0 20px;
  &.positive {
    color: #fff;
  }

  &.negative {
    color: #ff4444;
  }
}

.expand-icon {
  cursor: pointer;
  font-size: 24px;
  color: #888;
  transition: transform 0.3s;

  &.expand-open {
    transform: rotate(180deg);
  }
}

/* 展开详情 */
.record-detail {
  grid-column: 1 / -1;
  margin-top: 8px;
  // border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  color: #fff;
  font-weight: 500;
  min-width: 80px;
  padding:0 20px;
}

.detail-value {
  color: #fff;
  text-align: right;
  flex: 1;
  word-break: break-all;
	padding:0 20px;
  &.positive {
    color: #fff;
  }

  &.negative {
    color: #ff4444;
  }

  &.win {
    color: #22cc61;
  }

  &.lose {
    color: #ff4500;
  }

  &.pending {
    color: #999;
  }
}

/* 空状态 */
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px 16px;
}
</style>